import mime from 'mime';
import axios from 'axios';
import fileDownload from 'js-file-download';
import Logger from './Logger';

const getMimeType = (filename: string) => {
  const splitByDot = filename.split('.');
  const ext = splitByDot[splitByDot.length - 1];

  return mime.getType(ext) || '*/*';
};

const getExtension = (mimeType: string) => {
  return mime.getExtension(mimeType);
};

const download = async (
  filename: string,
  url: string,
  headers: Record<string, string | number | null> = {},
  mimeType?: string
) => {
  try {
    const { data } = await axios.get(`${url}`, { headers, responseType: 'blob' });
    fileDownload(data, filename);
  } catch (err) {
    Logger.error('FileServices: Failed to download file', { filename, url });

    throw err;
  }
};

const FileServices = {
  getMimeType,
  download
};

export default FileServices;
